import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { OrganizationItemFacade } from './organization-item.facade';

@Injectable({
  providedIn: 'root',
})
export class OrganizationItemGuard {
  constructor(private organizationItemFacade: OrganizationItemFacade) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const {
      params: { organizationId },
    } = route;
    return loadStoreState(this.organizationItemFacade, organizationId);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.organizationItemFacade);
  }
}
